export const ACCESS_TOKEN = 'access_token';

export const ACTION_ADD = 'ADD';
export const ACTION_EDIT = 'EDIT';

export const ROLES = {
  ROLE_USER: 'USER',
  ROLE_ADMIN: 'ADMIN',
  ROLE_STORE_MANAGER: 'STORE_MANAGER',
  ROLE_BOOK_MANAGER: 'BOOK_MANAGER'
};

export const MENU_ITEMS = [
  {
    name: 'Lili Player',
    path: '/bai-hat',
    key: 'home',
    level: 1,
    enabled: true,
    subItems: null
  },
  {
    name: 'About',
    path: '/about',
    key: 'about',
    level: 1,
    enabled: true,
    subItems: null
  }
];

// Những URL nào ko có trong này là public URL, role nào cũng access được
export const ROLE_TABLE = {
  '/book': [ROLES.ROLE_USER],
  '/staff': [ROLES.ROLE_STORE_MANAGER],
  '/fetch-demo': [ROLES.ROLE_USER]
};

export const STAFF_ALIVE = 1;
export const STAFF_DEAD = 0;

export const GENDERS = {
  MALE: 'male',
  FEMALE: 'female',
  GAY: 'gay',
  LESBIAN: 'lesbian',
  UNKNOWN: 'unknown'
};

export const LILIANA_SETTINGS = 'LILIANA_SETTINGS';
export const SETTING_APP_THEME = 'appTheme';

export const SEQUENCE = 'SEQUENCE';
export const SHUFFLE = 'SHUFFLE';
export const REPEAT_ONE = 'REPEAT_ONE';
export const playTypeList = [SEQUENCE, SHUFFLE, REPEAT_ONE];
export const playTypeCssList = ['fa-long-arrow-right', 'fa-random', 'fa-repeat'];
export const playTypeTitleList = ['Sequence', 'Shuffle', 'Repeat one'];
// export const playTypeSvgList = [BTN_SEQUENCE_SVG, BTN_SHUFFLE_SVG, BTN_REPEAT_ONE_SVG];
export const NO_LYRIC = `Sorry! This song has no lyric yet! You can contribute lyric by
  sending it to me:<br/><a href='mailto:taanhtu95@gmail.com'>Mail</a><br/>
  <a href='https://fb.com/anhtuta95' target='_blank'>FB</a>`;
export const FETCHING_LYRIC = 'Fetching lyric, please wait...';
export const LYRIC_NOT_FOUND = "Lyric doesn't exist!";

export const THEME_LIGHT = 'light';
export const THEME_DARK = 'dark';
